var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'Auth' || _vm.alreadyAuth1)?_c('Header',{ref:"header"}):_vm._e(),(_vm.$route.name == 'Auth' || _vm.alreadyAuth1)?_c('div',{staticClass:"container-md container-fluid mt-7 py-4"},[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }